const STEPS = [
  {
    num: '01',
    icon: 'ri-settings-3-line',
    title: 'Select Your Level',
    desc: 'Choose your challenge type and difficulty — Easy, Medium, Hard, or Expert. You control the pace.',
  },
  {
    num: '02',
    icon: 'ri-question-line',
    title: 'Receive the Question',
    desc: 'A fresh math problem is generated each round. Higher difficulties unlock timers to add pressure.',
  },
  {
    num: '03',
    icon: 'ri-cursor-line',
    title: 'Answer & Score Points',
    desc: 'Pick the right answer to win the point. Wrong answers give the CPU a point. Tennis scoring applies.',
  },
  {
    num: '04',
    icon: 'ri-trophy-line',
    title: 'Win the Match',
    desc: 'Win 2 sets to win the match. Can you beat the CPU and become the Math Tennis Champion?',
  },
];

export default function HowToPlaySection() {
  return (
    <section className="py-20 px-6 bg-green-900 text-white">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <span className="text-xs font-bold uppercase tracking-widest text-lime-400 bg-lime-400/10 border border-lime-400/30 px-3 py-1 rounded-full">
            How It Works
          </span>
          <h2
            className="text-4xl font-bold text-white mt-3"
            style={{ fontFamily: "'Bebas Neue', sans-serif", letterSpacing: '0.04em' }}
          >
            YOUR PATH TO VICTORY
          </h2>
          <p className="text-green-300 mt-2 max-w-sm mx-auto text-sm">
            Four simple steps stand between you and the trophy. Are you ready?
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {STEPS.map((step, i) => (
            <div key={step.num} className="relative">
              {i < STEPS.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-full w-full h-0.5 bg-green-700 -translate-y-0.5 z-0" style={{ width: 'calc(100% - 3rem)', left: '3.5rem' }} />
              )}
              <div className="relative z-10 flex flex-col items-center text-center gap-3">
                <div className="w-16 h-16 flex items-center justify-center rounded-full bg-green-800 border-2 border-lime-400/30">
                  <i className={`${step.icon} text-2xl text-lime-400`} />
                </div>
                <span className="text-xs text-lime-400 font-bold tracking-widest">{step.num}</span>
                <h3 className="font-bold text-white">{step.title}</h3>
                <p className="text-green-300 text-sm leading-relaxed">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Scoring table */}
        <div className="mt-14 bg-green-800/60 rounded-2xl p-6 border border-green-700">
          <h3 className="text-center font-bold text-lime-300 mb-4 text-sm uppercase tracking-widest">
            Tennis Scoring Reference
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-3 text-center">
            {[
              { label: 'No Points', value: '0' },
              { label: 'First Point', value: '15' },
              { label: 'Second Point', value: '30' },
              { label: 'Third Point', value: '40' },
              { label: 'Win Game', value: 'Game!' },
            ].map(item => (
              <div key={item.label} className="bg-green-900/60 rounded-xl py-3 px-2">
                <div className="text-2xl font-bold text-lime-400" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>
                  {item.value}
                </div>
                <div className="text-green-300 text-xs mt-1">{item.label}</div>
              </div>
            ))}
          </div>
          <p className="text-center text-green-400 text-xs mt-3">
            If both players reach 40 — <strong className="text-lime-400">Deuce</strong>! Win 2 consecutive points to claim the game.
          </p>
        </div>
      </div>
    </section>
  );
}
